const config = {
  DOMAIN: "http://localhost/ssj_queue_online/",
  SITE: "ssj_nont",
  LOGO: "logo/logo.png",
  API_URL_DEV: "http://localhost/ssj_queue_online/",
  FRONT_URL_DEV: "http://localhost:8080/queue-online",
  API_URL_PROD: "https://queue-nontfda.moph.go.th/",
  FRONT_URL_PROD: "https://queue-nontfda.moph.go.th",
  LINE_OA: "@fdanont",
  LINE_CLIENT_ID: "2006820848",
  LINE_CLIENT_SECRET : 'e949ef9a9fd08d832a88b4cc7b071b82',
  LINE_REDIRECT_URI: "https://queue-nontfda.moph.go.th/api/line_callback.php",
  LINE_URL_ADD_FRIEND: "https://lin.ee/6eIYqSK",

};

export { config };
